import { serverApi } from "./http";

export interface Site {
    id: number;
    sort?: number;
    text: string;
    homePath: string;
    localPath: string;
    jdkPath?: string;
    sshProfileId?: number;
    sshProfileName?: string;
    compileCacheStatus?: "NOT_READY" | "BUILDING" | "READY" | "FAILED" | "UNSUPPORTED";
    compileCacheMessage?: string;
    sshHost?: string;
    sshPort?: number;
    sshUsername?: string;
    sshAuthType?: "PASSWORD" | "PRIVATE_KEY";
    sshPrivateKeyPath?: string;
    remoteUploadPath?: string;
    strictHostKeyChecking?: boolean;
    hasStoredSshPassword?: boolean;
    useYn?: string;
    field?: string;
    value?: string;
}

export const getSites = async (): Promise<Site[]> => {
    const response = await serverApi.get<Site[]>("/api/sites");
    return response.data;
};

export const updateSiteOrder = async (siteIds: number[]): Promise<Site[]> => {
    const response = await serverApi.put<Site[]>("/api/sites/order", { siteIds });
    return response.data;
};
